import { useRef, useState, useEffect } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { toast } from "react-toastify";
import { OverlayTrigger, Popover, ProgressBar, Button } from "react-bootstrap";
import ReactSelect from "react-select";
import ReactStars from "react-stars";
import TagsInput from "react-tagsinput";
import { v4 as uuid } from "uuid";
import {
  CustomTooltip,
  DefaultUserDropdown,
  LoadingScreen,
  UserHover,
} from "Components";
import { GlobalChat } from "Components/Modal";
import { Columns } from "./Columns";
import { Filters } from "./Filters";
import { OfferLetter } from "./OfferLetter";
import { ApplicantDetails } from "./ApplicantDetails";
import { newAuthService } from "Service/Axios";
import {
  PROJECT_TABLE_USERSAVE_URL,
  REPLY_COMMENT_URL,
  TAG_LIST_BY_TASK__URL,
  TAG_UPDATE_BY_TASK_URL,
  USER_LIST_BY_TASK_URL,
  UPDATE_USER_LIST_BY_TASK_URL,
  GET_PROJECT_SETTINGS_URl,
  PROJECT_CLEAR_FILTER_SEARCH_URL,
  UPDATE_MULTIPLE_TASK_DECISION_URL,
  PROJECT_HEADERS_URL,
  DASHBOARD_URL,
  UPDATE_MULTIPLE_TASK_DOCUMENT_URL,
  SCORES_BY_TASK__URL,
  GET_TASK_USER_RATING_URL,
  UPLOAD_TASK_URL,
  EXPORT_PROJECT_URL,
  getTaskUniversityRankingListUrl,
  getTaskDecisionUserListUrl,
} from "Constant/api";
import {
  useApplicationStage,
  useFilterList,
  useProjectActionList,
} from "Constant/apiHooks";
import { paths } from "Constant/paths";
import { DEFAULT_DOCUMENT_TYPE, DOCUMENT_TYPES } from "Constant/constants";
import { useOutsideClick } from "Utils/hooks";
import {
  dynamicKeySortAscending,
  dynamicKeySortDescending,
  getFirstLetterOfName,
  getFileNameFromUrl,
  downloadFile,
  convertDynamicArrayByKey,
  formatDateWithFullMonthTime,
  uploadHandler,
  handleNumberWithTwoDecimal,
  formatDateWithShortMonth,
} from "Utils";
import "react-tagsinput/react-tagsinput.css";

export default function Projects() {
  const { t } = useTranslation();
  const { projectid } = useParams();
  const navigate = useNavigate();

  const tableRef = useRef();
  const abortControllerRef = useRef(null);
  const fetching = useRef(true);
  const page = useRef(0);
  const totalApplicants = useRef(1);
  const globalStage = useRef("");
  const defaultExecutionId = uuid();
  const uniqueExecutionId = useRef(defaultExecutionId);

  const [tableLoading, setTableLoading] = useState(true);
  const [actionLoading, setActionLoading] = useState(false);
  const [assigneeLoading, setAssigneeLoading] = useState(false);
  const [filtersModal, setFiltersModal] = useState(false);
  const [columnsModal, setColumnsModal] = useState(false);
  const [offerLetterModal, setOfferLetterModal] = useState(false);
  const [emailTemplateModal, setEmailTemplateModal] = useState(false);
  const [applicantDetailsModal, setApplicantDetailsModal] = useState(false);

  // const [currentStage, setCurrentStage] = useState("");
  const [replyComment, setReplyComment] = useState("");
  const [addNotes, setAddNotes] = useState("");
  const [showPopover, setShowPopover] = useState("");
  const [commnentPopover, setCommnentPopover] = useState("");
  const [attachmentPopover, setAttachmentPopover] = useState("");
  const [assigneePopover, setAssigneePopover] = useState("");
  const [tagPopover, setTagPopover] = useState("");
  const [selectedApplicantId, setSelectedApplicantId] = useState("");

  const [filterCount, setFilterCount] = useState(0);

  const [headerList, setHeaderList] = useState([]);
  const [searchArr, setSearchArr] = useState([]);
  const [applicantList, setApplicantList] = useState([]);
  const [assigneeList, setAssigneeList] = useState([]);
  const [duplicateAssigneeList, setDuplicateAssigneeList] = useState([]);
  const [tagsList, setTagsList] = useState([]);
  const [duplicateTagsList, setDuplicateTagsList] = useState([]);
  const [avarageRatingUserList, setAvarageRatingUserList] = useState([]);
  const [avarageScoreUserList, setAvarageScoreUserList] = useState([]);
  const [universityRankingList, setUniversityRankingList] = useState([]);
  const [decisionUserList, setDecisionUserList] = useState([]);
  const [selectedIds, setSelectedIds] = useState([]);

  const [isCommentShow, setIsCommentShow] = useState({
    isOpen: false,
    taskId: "",
  });

  const {
    filterList,
    setFilterList,
    duplicateFilterList,
    // loading: filterLoading,
  } = useFilterList(projectid);

  const {
    projectActionList: actionList,
    // loading: actionListLoading,
    fetchProjectActionList,
  } = useProjectActionList(projectid, globalStage.current);

  const {
    projectName,
    // applicationStage,
    applicationStageSlider,
    applicationStageDropdown,
    defaultStageId,
    // loading: applicationStageLoading,
    fetchApplicationStage,
  } = useApplicationStage(projectid);

  // Modal
  const toggleCommentModal = (taskId) => {
    if (taskId) {
      setIsCommentShow({
        taskId,
        isOpen: true,
      });
    } else {
      setIsCommentShow({
        taskId: "",
        isOpen: false,
      });
    }
  };

  const toggleColumsModal = () => {
    setColumnsModal(!columnsModal);
  };

  const toggleFiltersModal = () => {
    setFiltersModal(!filtersModal);
  };

  const toggleOfferLetterModal = () => {
    setOfferLetterModal(!offerLetterModal);
  };

  const toggleEmailTemplateModal = () => {
    setEmailTemplateModal(!emailTemplateModal);
  };

  const toggleApplicantDetailsModal = (gid) => {
    if (gid) {
      setSelectedApplicantId(gid);
    }
    setApplicantDetailsModal(!applicantDetailsModal);
  };

  // Mouse Enter & Leave
  const handleMouseEnter = (popoverId) => {
    setShowPopover(popoverId);
  };

  const handleMouseLeave = () => {
    setShowPopover("");
  };

  const handleCommnentMouseEnter = (popoverId) => {
    setCommnentPopover(popoverId);
  };

  const handleCommnentMouseLeave = () => {
    setCommnentPopover("");
  };

  const handleAttachmentMouseEnter = (popoverId) => {
    setAttachmentPopover(popoverId);
  };

  const handleAttachmentMouseLeave = () => {
    setAttachmentPopover("");
  };

  const handleAssigneeMouseEnter = (popoverId) => {
    setAssigneePopover(popoverId);
  };

  const handleAssigneeMouseLeave = () => {
    setAssigneePopover("");
  };

  const handleTagMouseEnter = (popoverId) => {
    setTagPopover(popoverId);
  };

  const handleTagMouseLeave = () => {
    setTagPopover("");
  };

  // Listing
  const getProjectSettings = async (signal) => {
    const payload = {
      projectId: projectid,
    };
    const response = await newAuthService(
      GET_PROJECT_SETTINGS_URl,
      "POST",
      payload,
      undefined,
      undefined,
      signal
    );
    if (response.status && response.data) {
      let responseFilter;
      let responseSearch;
      if (response.data.fieldsetting && response.data.fieldsetting.length > 0) {
        if (response.data.filterCount > 0) {
          responseFilter = response.data.fieldsetting;
          setFilterList(response.data.fieldsetting);
          setFilterCount(response.data.filterCount);
        }
      }
      if (response.data.searchText && response.data.searchText.length > 0) {
        responseSearch = response.data.searchText;
        setSearchArr(response.data.searchText);
      }
      globalStage.current = response.data.stageId;
      fetchProjectActionList(projectid, response.data.stageId);
      // const activeStageIndex =
      //   applicationStage?.findIndex(
      //     (stage) => stage.stageId === response.data.stageId
      //   ) || 0;
      // sliderRef.current.slickGoTo(activeStageIndex);
      fetchApplicantList(
        globalStage.current,
        responseFilter,
        responseSearch,
        undefined,
        uniqueExecutionId.current
      );
    } else {
      fetchApplicantList(
        globalStage.current,
        undefined,
        undefined,
        undefined,
        uniqueExecutionId.current
      );
    }
  };

  useEffect(() => {
    if (defaultStageId) {
      // sliderRef.current.slickGoTo(0);
      globalStage.current = defaultStageId;
      fetching.current = true;
      page.current = 0;
      totalApplicants.current = 1;
      const newEventId = uuid();
      uniqueExecutionId.current = newEventId;
      setApplicantList([]);
      setSearchArr([]);
      getProjectSettings();
    }
    // return () => {
    //   // Abort ongoing requests when dependencies change or component unmounts
    //   abortControllerRef.current?.abort();
    // };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [projectid, defaultStageId]);

  const fetchApplicantHeaderList = async () => {
    try {
      const headerPayload = {
        gid: projectid,
        projectType: "dashboard",
        stageId: globalStage.current,
      };
      const headerResponse = await newAuthService(
        PROJECT_HEADERS_URL,
        "POST",
        headerPayload
      );
      if (headerResponse.status && headerResponse.data) {
        setHeaderList(headerResponse.data);
      }
    } catch (error) {
      //console.error("Error fetching.current  header list:", error);
    } finally {
    }
  };

  useEffect(() => {
    fetchApplicantHeaderList();
  }, [globalStage.current, projectid]);

  const fetchApplicantList = async (stage, filters, search, sorting, event) => {
    // Cancel any previous request
    if (abortControllerRef.current) {
      abortControllerRef.current.abort();
    }

    if (uniqueExecutionId.current !== event) {
      abortControllerRef.current.abort();
      return;
    }

    abortControllerRef.current = new AbortController();

    setTableLoading(true);

    while (
      fetching.current &&
      page.current * 20 < totalApplicants.current &&
      uniqueExecutionId.current === event
    ) {
      try {
        const payload = {
          gid: projectid,
          projectType: "dashboard",
          stageId: stage,
          take: 20,
          skip: page.current * 20,
        };

        if (filters && filters.length > 0) {
          payload.filters = filters;
        }
        if (search && search.length > 0) {
          payload.search = search;
        }
        if (sorting) {
          payload.sorting = sorting;
        }

        const response = await newAuthService(
          DASHBOARD_URL,
          "POST",
          payload,
          undefined,
          undefined,
          abortControllerRef.current.signal
        );
        if (response.status && response.data && response.data.sucess) {
          if (uniqueExecutionId.current === event) {
            setTableLoading(false);
            totalApplicants.current = response.data.total;
            setFilterCount(response.data.filterCount);
            let result = convertDynamicArrayByKey(response.data.data);
            setApplicantList((prevList) => {
              return [...prevList, ...result];
            });
            page.current += 1;
          }
        } else {
          fetching.current = true;
        }
      } catch {
        setTableLoading(false);
        fetching.current = false;
      }
    }
  };

  // useEffect(() => {
  //   if (!pathname.includes(paths.admin.projects)) {
  //     return () => {
  //       fetching.current = false;
  //     };
  //   }
  // }, [pathname]); // Re-run effect when fetching.current  state changes

  const updateApplicationStage = (stageId) => {
    const newEventId = uuid();
    uniqueExecutionId.current = newEventId;
    globalStage.current = stageId;
    page.current = 0;
    totalApplicants.current = 1;
    fetching.current = true;
    setApplicantList([]);

    fetchApplicantList(stageId, undefined, undefined, undefined, newEventId);
  };

  // const getUserDetailsByTask = async (gid) => {
  //   const data = {
  //     gid,
  //   };
  //   const response = await newAuthService(getTaskUserDetailsUrl, "POST", data);
  //   if (response.status) {
  //     setUserDetails(response.data);
  //   } else {
  //     setUserDetails(response);
  //   }
  // };

  const getAssigneeListByTask = async (gid) => {
    setAssigneeLoading(true);
    const data = {
      gid,
    };
    const response = await newAuthService(USER_LIST_BY_TASK_URL, "POST", data);
    if (response.status) {
      setAssigneeList(response.data);
      setDuplicateAssigneeList(JSON.parse(JSON.stringify(response.data)));
      setAssigneeLoading(false);
    } else {
      setAssigneeList(response);
      setDuplicateAssigneeList([]);
      setAssigneeLoading(false);
    }
  };

  const getTagListByTask = async (gid) => {
    const data = {
      gid,
    };
    const response = await newAuthService(TAG_LIST_BY_TASK__URL, "POST", data);
    if (response.status) {
      setTagsList(response.data);
      setDuplicateTagsList(JSON.parse(JSON.stringify(response.data)));
    } else {
      setTagsList([]);
      setDuplicateTagsList([]);
    }
  };

  const getAvarageRatingUsersByTask = async (gid) => {
    const data = {
      gid,
    };
    const response = await newAuthService(
      GET_TASK_USER_RATING_URL,
      "POST",
      data
    );
    if (response.status) {
      setAvarageRatingUserList(response.data);
    }
  };

  const getAvarageScoreUsersByTask = async (gid) => {
    const data = {
      gid,
    };
    const response = await newAuthService(SCORES_BY_TASK__URL, "POST", data);
    if (response.status) {
      setAvarageScoreUserList(response.data);
    } else {
      setAvarageScoreUserList([]);
    }
  };

  const getUniversityRankingByTask = async (gid, questionId) => {
    const data = {
      gid,
      questionId,
    };
    const response = await newAuthService(
      getTaskUniversityRankingListUrl,
      "POST",
      data
    );
    if (response.status) {
      setUniversityRankingList(response.data);
    } else {
      setUniversityRankingList([]);
    }
  };

  const getDecisionUserListByTask = async (gid, questionId) => {
    const data = {
      gid,
      questionId,
    };
    const response = await newAuthService(
      getTaskDecisionUserListUrl,
      "POST",
      data
    );
    if (response.status) {
      setDecisionUserList(response.data);
    } else {
      setDecisionUserList([]);
    }
  };

  // Sorting
  const handleSortDescending = async (key) => {
    // Sort Using API If Full Data Not Loaded
    // if (applicantList.length < totalApplicants.current) {
    //   setApplicantList([]);
    //   const sorting = {
    //     questionName: key,
    //     type: "DESC",
    //   };
    //   fetchApplicantList(0, globalStage.current, filterList, searchArr, sorting);
    // } else {
    //   const response = dynamicKeySortDescending([...applicantList], key);
    //   setApplicantList(response);
    // }
    const response = dynamicKeySortDescending([...applicantList], key);
    setApplicantList(response);
  };

  const handleSortAscending = async (key) => {
    // Sort Using API If Full Data Not Loaded
    // if (applicantList.length < totalApplicants.current) {
    //   setApplicantList([]);
    //   const sorting = {
    //     questionName: key,
    //     type: "ASC",
    //   };
    //   fetchApplicantList(0, globalStage.current, filterList, searchArr, sorting);
    // } else {
    //   const response = dynamicKeySortAscending([...applicantList], key);
    //   setApplicantList(response);
    // }
    const response = dynamicKeySortAscending([...applicantList], key);
    setApplicantList(response);
  };

  // On Click
  const onResetFilterAndSearch = async () => {
    const payload = {
      projectId: projectid,
    };
    await newAuthService(PROJECT_CLEAR_FILTER_SEARCH_URL, "POST", payload);
    setApplicantList([]);
    setFilterList(duplicateFilterList);
    setFilterCount(0);
    setSearchArr([]);
    fetching.current = true;
    page.current = 0;
    totalApplicants.current = 1;
    const newEventId = uuid();
    uniqueExecutionId.current = newEventId;
    fetchApplicantList(
      globalStage.current,
      undefined,
      undefined,
      undefined,
      newEventId
    );
  };

  // On Change
  const handleChange = (e) => {
    if (e.target.name === "replyComment") {
      setReplyComment(e.target.value);
    }
    if (e.target.name === "addNotes") {
      setAddNotes(e.target.value);
    }
  };

  const onReplyComment = async (comment, taskId, commentNo) => {
    const payload = {
      // chatDetails: type === "reply" ? replyComment : addNotes,
      chatDetails: replyComment,
      taskId,
      replyId: comment?.gid,
    };
    const response = await newAuthService(REPLY_COMMENT_URL, "POST", payload);
    if (response.status) {
      // For applicantList update with new Assignee
      // const applicantArr = [...applicantList];
      // const applicantIndex = applicantList.findIndex(
      //   (applicant) => applicant.id === taskId
      // );
      // if (applicantIndex !== -1) {
      //   applicantArr[applicantIndex]["Comments"]["comments"] = response.data;
      //   applicantArr[applicantIndex]["Comments"]["value"] = commentNo + 1;
      //   setApplicantList(applicantArr);
      // }

      // Update the comments in the existing applicant list
      setApplicantList((prevList) => {
        return prevList.map((applicant) => {
          if (applicant.id === taskId) {
            return {
              ...applicant,
              Comments: {
                ...applicant.Comments,
                comments: response.data,
                value: commentNo + 1,
              },
            };
          }
          return applicant;
        });
      });

      setReplyComment("");
      setAddNotes("");
    }
  };

  const handleSearch = (tags) => {
    const newEventId = uuid();
    fetching.current = true;
    page.current = 0;
    totalApplicants.current = 1;
    uniqueExecutionId.current = newEventId;
    setSearchArr(tags);
    setApplicantList([]);
    fetchApplicantList(
      globalStage.current,
      filterList,
      tags,
      undefined,
      newEventId
    );
  };

  // Columns
  const onApplyColumnChanges = () => {
    // Refresh Header List
    fetchApplicantHeaderList();
    // Refresh Applicant List
    const newEventId = uuid();
    fetching.current = true;
    page.current = 0;
    totalApplicants.current = 1;
    uniqueExecutionId.current = newEventId;
    setApplicantList([]);
    fetchApplicantList(
      globalStage.current,
      filterList,
      searchArr,
      undefined,
      newEventId
    );
  };

  // Filter
  const onApplyFilter = async (
    filterList
    // ,count
  ) => {
    // setFilterCount(count);
    setFilterList(filterList);
    page.current = 0;
    totalApplicants.current = 1;
    const newEventId = uuid();
    uniqueExecutionId.current = newEventId;
    setApplicantList([]);
    fetching.current = true;
    fetchApplicantList(
      globalStage.current,
      filterList,
      searchArr,
      undefined,
      newEventId
    );
  };

  const onResetFilter = () => {
    setFilterList(duplicateFilterList);
    setFilterCount(0);
    toggleFiltersModal();
    page.current = 0;
    totalApplicants.current = 1;
    const newEventId = uuid();
    uniqueExecutionId.current = newEventId;
    fetching.current = true;
    fetchApplicantList(
      globalStage.current,
      filterList,
      searchArr,
      undefined,
      newEventId
    );
  };

  // Table
  const handleTableEditFeild = (key, index) => {
    const falseArr = [...applicantList];
    for (let i = 0; i <= falseArr.length; i++) {
      for (const keyD in falseArr[i]) {
        if (falseArr[i][keyD] && falseArr[i][keyD].makeEditable) {
          falseArr[i][keyD].makeEditable = false;
        }
      }
    }
    let newArr = [...falseArr];
    newArr[index][key].makeEditable = true;
    setApplicantList(newArr);
  };

  const handleTableInputChange = (e, key, index) => {
    let newArr = [...applicantList];
    newArr[index][key].value = e.target.value;
    setApplicantList(newArr);
    if (e.target.type === "date") {
      onSubmitTableEditFeild(e.target.value, newArr[index], key);
    }
  };

  const handleTableKeyPress = (e, data, key, type) => {
    if (type === "number") {
      handleNumberWithTwoDecimal(e);
    }
    if (e.key === "Enter") {
      onSubmitTableEditFeild(e.target.value, data, key);
    }
  };

  const handleTableSelectChange = (value, key, index) => {
    let newArr = [...applicantList];
    // With React Select
    // newArr[index][key].value = value.label;
    // With Normal Select
    newArr[index][key].value = value;
    setApplicantList(newArr);

    // With Normal Select
    onSubmitTableEditFeild(value, newArr[index], key);
  };

  // const handleTableSelectPress = (e, value, data, key) => {
  //   if (e.key === "Enter") {
  //     // With React Select
  //     // onSubmitTableEditFeild(value.label, data, key);
  //     // With Normal Select
  //     onSubmitTableEditFeild(value, data, key);
  //   }
  // };

  const handleTableRatingChange = (value, data, key) => {
    onSubmitTableEditFeild(value, data, key);
  };

  const onSubmitTableEditFeild = async (value, data, key) => {
    const obj = data && data[key];
    const payload = {
      gid: data.id,
      questionName: obj.questionName,
      questionId: obj.questionId,
      valueChange: true,
      value,
    };
    await newAuthService(PROJECT_TABLE_USERSAVE_URL, "POST", payload);
    toast.success(t("common.messages.notification.success.updateDetails"));
    const newArr = [...applicantList];
    const indexToUpdate = newArr.findIndex((item) => item.id === payload.gid);
    const questionName = obj.questionName || obj.name;
    if (
      indexToUpdate !== -1 &&
      questionName &&
      newArr[indexToUpdate][questionName] !== undefined
    ) {
      newArr[indexToUpdate][questionName].makeEditable = false;
      newArr[indexToUpdate][questionName].value = value;
    }
    setApplicantList(newArr);
  };

  const handleChangeTags = async (e, taskId, tagIndex) => {
    const newArr = [...tagsList];
    newArr[tagIndex].checked = e.target.checked;
    setTagsList(newArr);
    // For Api Tag List with TaskId
    const duplicateArr = newArr.map((t) => ({
      ...t,
      taskId,
    }));
    await newAuthService(TAG_UPDATE_BY_TASK_URL, "POST", duplicateArr);
    // getApprovalList();
    // // For applicantList update with new Tags
    // const applicantArr = [...applicantList];
    // const applicantIndex = applicantList.findIndex(
    //   (applicant) => applicant.id === taskId
    // );
    // if (applicantIndex !== -1) {
    //   const checkedTagArr = newArr.filter((tag) => tag.checked);
    //   applicantArr[applicantIndex]["Tag"]["tags"] = checkedTagArr;
    //   setApplicantList(applicantArr);
    // }

    // Update the tags in the existing applicant list
    setApplicantList((prevList) => {
      return prevList.map((applicant) => {
        if (applicant.id === taskId) {
          // Filter the updated assignees
          const checkedTagArr = newArr.filter((assignee) => assignee.checked);
          return {
            ...applicant,
            Tag: {
              ...applicant.Tag,
              tags: checkedTagArr,
            },
          };
        }
        return applicant;
      });
    });
  };

  const handleSearchTags = (e) => {
    if (e.target.value.length > 0) {
      const searchedData = duplicateTagsList.filter((option) =>
        option.name.toLowerCase().includes(e.target.value.toLowerCase())
      );
      setTagsList(searchedData);
    } else {
      setTagsList(duplicateTagsList);
    }
  };

  const handleChangeAssigne = async (updatedAssigneeList, taskId) => {
    setDuplicateAssigneeList(updatedAssigneeList);
    // For assignee update API
    await newAuthService(
      UPDATE_USER_LIST_BY_TASK_URL,
      "POST",
      updatedAssigneeList
    );

    // // For applicantList update with new Assignee
    // const applicantArr = [...applicantList];
    // const applicantIndex = applicantList.findIndex(
    //   (applicant) => applicant.id === taskId
    // );
    // if (applicantIndex !== -1) {
    //   const checkedAssigneeArr = updatedAssigneeList.filter(
    //     (applicant) => applicant.check
    //   );
    //   applicantArr[applicantIndex]["Assignee"]["userDetails"] =
    //     checkedAssigneeArr;
    //   setApplicantList(applicantArr);
    // }

    // Update the assignee in the existing applicant list
    setApplicantList((prevList) => {
      return prevList.map((applicant) => {
        if (applicant.id === taskId) {
          // Filter the updated assignees
          const checkedAssigneeArr = updatedAssigneeList.filter(
            (assignee) => assignee.check
          );
          return {
            ...applicant,
            Assignee: {
              ...applicant.Assignee,
              userDetails: checkedAssigneeArr,
            },
          };
        }
        return applicant;
      });
    });
  };

  const disableTableEdit = () => {
    const newArr = [...applicantList];
    for (var i = 0; i <= newArr.length; i++) {
      for (var key in newArr[i]) {
        if (newArr[i][key].makeEditable) {
          newArr[i][key].makeEditable = false;
        }
      }
    }
    setApplicantList(newArr);
  };

  useOutsideClick(tableRef, () => disableTableEdit());

  const handleSelectRow = (e) => {
    const { name, checked } = e.target;
    if (name === "all") {
      const tempUser = applicantList.map((user) => {
        return { ...user, isChecked: checked };
      });
      setApplicantList(tempUser);
    } else {
      const tempUser = applicantList.map((user) =>
        user.id === name ? { ...user, isChecked: checked } : user
      );
      setApplicantList(tempUser);
    }
  };

  useEffect(() => {
    const ids = [];
    for (let i = 0; i < applicantList.length; i++) {
      if (applicantList[i].isChecked) {
        ids.push(applicantList[i].id);
      }
    }
    setSelectedIds(ids);
  }, [applicantList]);

  // Table Actions
  const onSubmitAction = async (name) => {
    fetching.current = false;
    uniqueExecutionId.current = "undefined";
    setActionLoading(true);
    try {
      const payload = {
        gid: selectedIds,
        decision: name,
      };
      const response = await newAuthService(
        UPDATE_MULTIPLE_TASK_DECISION_URL,
        "POST",
        payload
      );
      setActionLoading(false);
      if (response.status && response.data.success) {
        toast.success(t("common.messages.notification.success.updateStatus"));
        const newApplicationStage = await fetchApplicationStage();
        if (applicantList.length < totalApplicants.current) {
          // To Fix = Api Call Issue
          page.current = 0;
          totalApplicants.current = 1;
          const newEventId = uuid();
          uniqueExecutionId.current = newEventId;
          setApplicantList([]);
          fetching.current = true;
          fetchApplicantList(
            globalStage.current,
            filterList,
            searchArr,
            undefined,
            newEventId
          );
        } else {
          const updatedApplicantList = applicantList.filter(
            (applicant) => !selectedIds.includes(applicant.id)
          );
          totalApplicants.current =
            newApplicationStage.find(
              (stage) => stage.stageId === globalStage.current
            )?.number || 1;
          setApplicantList(updatedApplicantList);
        }
      } else {
        // toast.error(response.message);
      }
    } catch (error) {
      setActionLoading(false);
      if (error.response && error.response.data) {
        toast.error(error.response.data.message);
      }
    }
  };

  const onExportAction = async () => {
    setActionLoading(true);
    try {
      const payload = {
        projectId: projectid,
        stageId: globalStage.current,
      };
      const response = await newAuthService(
        EXPORT_PROJECT_URL,
        "POST",
        payload,
        undefined,
        "arraybuffer"
      );
      setActionLoading(false);
      if (response.status) {
        const blob = new Blob([response.data], {
          type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=utf-8",
        });
        const link = document.createElement("a");
        if (link.download !== undefined) {
          const url = URL.createObjectURL(blob);
          link.setAttribute("href", url);
          link.setAttribute("download", `Sample.xlsx`);
          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link);
        } else {
          throw new Error();
        }
      } else {
        toast.error(response.message);
      }
    } catch (error) {
      setActionLoading(false);
      if (error.response && error.response.data) {
        toast.error(error.response.data.message);
      }
    }
  };

  const onUploadDocument = async (e, name) => {
    try {
      const fileResponse = await uploadHandler(
        e,
        "Table",
        DOCUMENT_TYPES,
        UPLOAD_TASK_URL,
        selectedIds
      );
      if (fileResponse) {
        try {
          const payload = {
            gid: selectedIds,
            decision: name,
            file: fileResponse,
          };
          const response = await newAuthService(
            UPDATE_MULTIPLE_TASK_DOCUMENT_URL,
            "POST",
            payload
          );
          if (response.status) {
            toast.success(
              t("common.messages.notification.success.updateStatus")
            );
            fetchApplicationStage();
            e.target.value = "";
          } else {
            toast.error(response.data.message);
          }
        } catch (error) {
          if (error.response && error.response.data) {
            toast.error(error.response.data.message);
          }
        }
      }
    } catch (error) {
      if (error.response && error.response.data) {
        toast.error(error.response.data.message);
      }
    }
  };

  useEffect(() => {
    const checkClassAndApplyBodyClass = () => {
      const element = document.querySelector(".project-table-height");

      if (element) {
        // Add the 'abcd' class to the body tag
        document.body.classList.add("hide-scroll");
      } else {
        // Remove the 'abcd' class from the body tag
        document.body.classList.remove("hide-scroll");
      }
    };

    // Call the function initially
    checkClassAndApplyBodyClass();

    // Observe DOM changes
    const observer = new MutationObserver(checkClassAndApplyBodyClass);
    observer.observe(document.body, { childList: true, subtree: true });

    // Cleanup the observer
    return () => observer.disconnect();
  }, []);

  // Render
  const tableHeaderRender = (key, type) => {
    return (
      <div className="form-check">
        {type === "firstChild" && (
          <input
            className="form-check-input"
            type="checkbox"
            checked={!applicantList.some((user) => user?.isChecked !== true)}
            id="all"
            name="all"
            onChange={handleSelectRow}
          />
        )}
        <label className="form-check-label" htmlFor="all">
          <div className="dropdown short-dropdown">
            <button
              className="dropdown-toggle"
              type="button"
              data-bs-toggle="dropdown"
              aria-expanded="false"
            >
              {key}
            </button>
            <ul className="dropdown-menu card-shadow">
              <li>
                <button
                  className="dropdown-item"
                  onClick={() => handleSortAscending(key)}
                >
                  <i className="bx bx-up-arrow-alt"></i>{" "}
                  {t("common.button.sortAscending")}
                </button>
              </li>
              <li>
                <button
                  className="dropdown-item"
                  onClick={() => handleSortDescending(key)}
                >
                  <i className="bx bx-down-arrow-alt"></i>{" "}
                  {t("common.button.sortDescending")}
                </button>
              </li>
            </ul>
          </div>
        </label>
      </div>
    );
  };

  const tableBodyRender = (data, singleData, key, index) => {
    if (singleData && singleData.designType === "user") {
      return (
        <div
          onMouseEnter={() =>
            handleMouseEnter(`${singleData.questionId}-${index}`, data.id)
          }
          onMouseLeave={handleMouseLeave}
        >
          <OverlayTrigger
            placement="right"
            show={showPopover === `${singleData.questionId}-${index}`}
            overlay={
              // userDetails &&
              singleData.userDetails &&
              singleData.userDetails.length > 0 && (
                <Popover
                  className="max-w-unset"
                  key={`${singleData.questionId}-${index}`}
                  id={`${singleData.questionId}-${index}`}
                >
                  <UserHover
                    // user={userDetails}
                    user={singleData.userDetails[0]}
                    isOverlayTrigger
                  />
                </Popover>
              )
            }
          >
            <div
              className="applicant-name cursor-pointer"
              onClick={() => toggleApplicantDetailsModal(data.id)}
            >
              {singleData.value}
            </div>
          </OverlayTrigger>
        </div>
      );
    } else if (singleData && singleData.designType === "rating") {
      const rating = Number(singleData.value);
      return (
        <div
          className={`${
            avarageRatingUserList && avarageRatingUserList.length > 0
              ? "applicant-dropdown"
              : ""
          } position-relative`}
        >
          <div
            className="ratings"
            onMouseEnter={() => {
              if (
                singleData?.value &&
                !isNaN(rating) &&
                rating > 0 &&
                singleData?.mouseHoverType === "averagerating"
              ) {
                getAvarageRatingUsersByTask(data.id);
              } else {
                setAvarageRatingUserList([]);
              }
            }}
            onMouseLeave={() => {
              setAvarageRatingUserList([]);
            }}
          >
            <ReactStars
              count={5}
              value={rating}
              size={16}
              color2={"#ffd700"}
              edit={singleData.editable}
              onChange={(value) => handleTableRatingChange(value, data, key)}
            />
          </div>
          {avarageRatingUserList &&
            avarageRatingUserList.length > 0 &&
            !isNaN(rating) &&
            rating !== 0 && (
              <div className="review-info-box card-shadow">
                {avarageRatingUserList.map((user, index) => (
                  <div
                    className="d-flex align-items-center column-gap-1 mb-2 progress-green-900"
                    key={index.toString()}
                  >
                    <div className="img-box rounded-circle overflow-hidden">
                      {user.photoURL ? (
                        <img
                          src={user.photoURL}
                          alt={`${user.firstName}-${user.lastName}`}
                          className="w-100 h-100 object-fit-cover"
                        />
                      ) : (
                        getFirstLetterOfName(user)
                      )}
                    </div>
                    <div className="ms-auto review-info-content">
                      <div className="d-flex align-items-center column-gap-1">
                        <div className="w-100">
                          <h6 className="mb-0 size-xs">
                            {user.firstName} {user.lastName}
                          </h6>
                        </div>
                        <div className="review-list d-flex">
                          <ReactStars
                            count={5}
                            value={Number(user.rating || 0)}
                            size={16}
                            color2={"#ffd700"}
                            edit={false}
                          />
                        </div>
                      </div>
                      <div className="progressbar-div mt-2">
                        <ProgressBar
                          min={0}
                          max={5}
                          now={Number(user.rating || 0)}
                        />
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            )}
        </div>
      );
    } else if (singleData && singleData.designType === "hyperlink") {
      return (
        <CustomTooltip text={singleData.value}>
          <a
            href={singleData.value}
            target="_blank"
            rel="noopener noreferrer"
            className="applicant-url"
          >
            {singleData.value}
          </a>
        </CustomTooltip>
      );
    } else if (singleData && singleData.designType === "status") {
      return (
        <div
          className="hover-effect position-relative cursor-pointer"
          onMouseEnter={() => {
            getDecisionUserListByTask(data.id, singleData.questionId);
          }}
        >
          <span
            className="badge pending badge-status"
            style={{
              backgroundColor: singleData.backgroundColor,
              color: singleData.fontColor,
            }}
          >
            {singleData.value}
          </span>
          {decisionUserList?.length > 0 && (
            <div className="max-w-600 p-1 rounded-3 shadow hover-box bg-white position-absolute top-100 end-0 z-3">
              <table className="status-table preview-table w-100 text-xs">
                <thead>
                  <tr>
                    <th>Assignee</th>
                    <th>Stage</th>
                    <th>Due date</th>
                    <th>Status</th>
                  </tr>
                </thead>
                <tbody>
                  {decisionUserList.map((decisionUser, decisionIndex) => (
                    <tr key={decisionIndex.toString()}>
                      <td>
                        <div className="new-avater d-flex align-items-center">
                          <div className="position-relative">
                            <div className="me-2 w-10 h-10 rounded-circle bg-grey-100 position-relative overflow-hidden">
                              {decisionUser?.userDetails?.photoURL ? (
                                <img
                                  src={decisionUser?.userDetails?.photoURL}
                                  alt={`${decisionUser?.userDetails?.firstName}${decisionUser?.userDetails?.lastName}`}
                                  className="w-100 h-100 object-fit-cover"
                                />
                              ) : (
                                getFirstLetterOfName(decisionUser?.userDetails)
                              )}
                            </div>
                          </div>
                          <div className="new-av-details">
                            <h4 className="mb-0 text-sm font-medium">
                              {decisionUser?.userDetails?.firstName}{" "}
                              {decisionUser?.userDetails?.lastName}
                            </h4>
                          </div>
                        </div>
                      </td>
                      <td>
                        <span className="px-2 py-1 text-blue-600 rounded-1 border-blue-300 bg-blue-100">
                          {decisionUser.stage}
                        </span>
                      </td>
                      <td>
                        {decisionUser.decisionDate &&
                          formatDateWithShortMonth(decisionUser.decisionDate)}
                      </td>
                      <td>
                        <span className="px-2 py-1 text-orange-600 rounded-1 border-orange-300 bg-orange-100">
                          {decisionUser.decision}
                        </span>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          )}
        </div>
      );
    } else if (singleData && singleData.designType === "assignee") {
      return (
        <>
          <div
            className="applicant-dropdown"
            onMouseEnter={() =>
              handleAssigneeMouseEnter(`${singleData.questionId}-${index}`)
            }
            onMouseLeave={handleAssigneeMouseLeave}
          >
            <OverlayTrigger
              placement="bottom"
              show={assigneePopover === `${singleData.questionId}-${index}`}
              overlay={
                <Popover id={`popover-${singleData.questionId}-${index}`}>
                  <div className="applicant-info-box p-3 rounded-3 border bg-white card-shadow assignee-list px-0 z-10">
                    <div className="assignee-list-date">
                      <ul>
                        {singleData.userDetails &&
                          singleData.userDetails.length > 0 &&
                          singleData.userDetails.map((user, index) => (
                            <li
                              className="assignee-item"
                              key={index.toString()}
                            >
                              <div className="form-check form-check-flex align-items-center">
                                <div className="assignee-user">
                                  {user.photoURL ? (
                                    <div className="img-box">
                                      <img
                                        src={user.photoURL}
                                        alt={`${user.firstName}${user.lastName}`}
                                      />
                                    </div>
                                  ) : (
                                    getFirstLetterOfName(user)
                                  )}
                                </div>
                                <div className="assignee-name">
                                  <p>
                                    {user.firstName} {user.lastName}
                                  </p>
                                </div>
                              </div>
                            </li>
                          ))}
                      </ul>
                    </div>
                  </div>
                </Popover>
              }
            >
              <div className="more-assignee-img">
                {singleData.userDetails &&
                  singleData.userDetails.length > 0 &&
                  singleData.userDetails.slice(0, 2).map((user, index) => (
                    <div
                      className="assignee_img"
                      key={`${user.firstName}${index}`}
                    >
                      {user.photoURL ? (
                        <div className="img-box bg-slate-100">
                          <img
                            src={user.photoURL}
                            alt={`${user.firstName}${user.lastName}`}
                          />
                        </div>
                      ) : (
                        getFirstLetterOfName(user)
                      )}
                    </div>
                  ))}
                {singleData.userDetails?.length > 2 && (
                  <div className="assignee_img">
                    <div className="w-8 h-8 rounded-circle border border-slate-50 bg-slate-200 d-flex justify-content-center align-items-center p-2 text-xs font-semibold text-slate-500">
                      +{singleData.userDetails?.length - 2}
                    </div>
                  </div>
                )}
              </div>
            </OverlayTrigger>
          </div>
          <div className="assignee-list btn-group dropend ms-1">
            <button
              className="button dropdown-toggle more-assignee w-8 h-8"
              type="button"
              data-bs-toggle="dropdown"
              aria-expanded="false"
              data-bs-auto-close="outside"
              onClick={() => getAssigneeListByTask(data.id)}
            >
              <i className="bx bx-plus"></i>
            </button>
            <ul className="dropdown-menu dropdown-custom-shadow">
              <DefaultUserDropdown
                loading={assigneeLoading}
                list={assigneeList}
                duplicateList={duplicateAssigneeList}
                taskId={data.id}
                onChange={handleChangeAssigne}
              />
            </ul>
          </div>
        </>
      );
    } else if (singleData && singleData.designType === "comment") {
      return (
        <>
          <i className="pluto-message"></i> {singleData.value}
          <div
            onMouseEnter={() =>
              handleCommnentMouseEnter(`${singleData.questionId}-${index}`)
            }
            onMouseLeave={handleCommnentMouseLeave}
          >
            <OverlayTrigger
              placement="left"
              show={commnentPopover === `${singleData.questionId}-${index}`}
              overlay={
                <Popover id={`popover-${singleData.questionId}-${index}`}>
                  <div className="p-3 rounded-3 border bg-slate-100 card-shadow z-10">
                    <div className="note-info pt-2">
                      <button
                        type="button"
                        className="button-expand"
                        onClick={() => {
                          toggleCommentModal(data.id);
                        }}
                      >
                        <i className="bx bx-expand-alt"></i>
                      </button>
                      {singleData.comments && (
                        <>
                          <div className="d-flex align-items-center py-3">
                            <div className="note-info-img me-2">
                              {singleData.comments.photoURL ? (
                                <img
                                  src={singleData.comments.photoURL}
                                  alt={`${singleData.comments.firstName}${singleData.comments.lastName}`}
                                />
                              ) : (
                                getFirstLetterOfName(singleData.comments)
                              )}
                            </div>
                            <div className="note-info-name">
                              <h6>
                                {singleData.comments.firstName}{" "}
                                {singleData.comments.lastName}{" "}
                                <small>
                                  {singleData.comments.createdOn &&
                                    formatDateWithFullMonthTime(
                                      singleData.comments.createdOn
                                    )}
                                </small>
                              </h6>
                            </div>
                          </div>
                          <div className="note-info-content">
                            <div
                              className="mb-3"
                              dangerouslySetInnerHTML={{
                                __html: singleData.comments.chatDetails,
                              }}
                            />
                          </div>
                        </>
                      )}
                    </div>
                    <div className="comment-btn input-group">
                      <input
                        type="text"
                        placeholder="Reply"
                        className="form-control"
                        name="replyComment"
                        value={replyComment}
                        onChange={handleChange}
                      />
                      <button
                        type="button"
                        className="comment-btn"
                        onClick={() =>
                          onReplyComment(
                            singleData.comments,
                            data.id,
                            Number(singleData.value)
                          )
                        }
                      >
                        <div className="add-note-btn">
                          <i className="bx bx-up-arrow-alt"></i>
                        </div>
                      </button>
                    </div>
                  </div>
                </Popover>
              }
            >
              <div className="hover-comment position-relative">
                <i className="bx bx-note"></i>
              </div>
            </OverlayTrigger>
          </div>
        </>
      );
    } else if (singleData && singleData.designType === "image") {
      const fileName = singleData.value && getFileNameFromUrl(singleData.value);
      return (
        <div className="graph_img">
          {singleData.value && (
            <>
              <div className="graph-hover">
                <span className="graph-name">
                  <i className="bx bx-link-alt"></i> {fileName}
                </span>
                <div className="graph-info-box card-shadow">
                  <div className="graph-over-header">
                    {fileName}
                    <div className="btn-group">
                      <button
                        type="button"
                        className="button"
                        onClick={() => downloadFile(singleData.value, fileName)}
                      >
                        <i className="bx bx-down-arrow-circle"></i>
                      </button>
                      <button
                        type="button"
                        className="button button-expand"
                        data-bs-toggle="modal"
                        data-bs-target="#graphleModal"
                      >
                        <i className="bx bx-expand-alt"></i>
                      </button>
                    </div>
                  </div>
                  <div className="graph-over-body">
                    <img src={singleData.value} alt={fileName} />
                  </div>
                </div>
              </div>

              <div
                className="modal fade"
                id="graphleModal"
                tabIndex="-1"
                aria-labelledby="graphleModalLabel"
                aria-hidden="true"
              >
                <div className="modal-dialog modal-xl modal-dialog-scrollable">
                  <div className="modal-content">
                    <button
                      type="button"
                      className="btn-close close-icon bg-alpha-0"
                      data-bs-dismiss="modal"
                      aria-label="Close"
                    >
                      <i className="bx bx-x bx-sm"></i>
                    </button>
                    <img src={singleData.value} alt={fileName} />
                  </div>
                </div>
              </div>
            </>
          )}
        </div>
      );
    } else if (singleData && singleData.designType === "tag") {
      return (
        <div className="tags">
          <div
            onMouseEnter={() =>
              handleTagMouseEnter(`${singleData.questionId}-${index}`, data.id)
            }
            onMouseLeave={handleTagMouseLeave}
          >
            <OverlayTrigger
              placement="left"
              show={tagPopover === `${singleData.questionId}-${index}`}
              overlay={
                <Popover id={`tagpopover-${singleData.questionId}-${index}`}>
                  <div className="p-2">
                    <ul className="tag-list-inline flex-wrap">
                      {singleData.tags &&
                        singleData.tags.length > 0 &&
                        singleData.tags.map((tag, index) => (
                          <li key={`${tag.gid}${index}`}>
                            <span
                              type="button"
                              className="badge bg-secondary tag-badge"
                            >
                              {tag.name}
                            </span>
                          </li>
                        ))}
                    </ul>
                  </div>
                </Popover>
              }
            >
              <div>
                {singleData.tags?.length > 0 ? (
                  <span type="button" className="badge bg-secondary tag-badge">
                    {singleData.tags[0].name}
                  </span>
                ) : (
                  ""
                )}
              </div>
            </OverlayTrigger>
          </div>

          <button
            className="more-tag dropdown-toggle btn-block"
            type="button"
            data-bs-toggle="dropdown"
            aria-expanded="false"
            data-bs-auto-close="outside"
            onClick={() => getTagListByTask(data.id)}
          >
            <i className="bx bxs-plus-circle"></i> {t("common.button.more")}
          </button>
          <ul className="dropdown-menu dropdown-custom-shadow p-3 tag-dropdown">
            <li className="search-div px-0">
              <div className="input-group">
                <input
                  type="search"
                  className="form-control"
                  placeholder={t("common.placeHolder.searchTags")}
                  onChange={handleSearchTags}
                />
                <button type="button" className="input-group-text">
                  <i className="pluto-search"></i>
                </button>
              </div>
            </li>
            <li>
              <div className="option-list">
                {tagsList &&
                  tagsList.length > 0 &&
                  tagsList.map((tag, tagIndex) => (
                    <div
                      className="form-check form-check-flex mt-3"
                      key={tagIndex.toString()}
                    >
                      <label className="form-check-label me-2" htmlFor="">
                        {tag.name}
                      </label>
                      <input
                        className="form-check-input"
                        type="checkbox"
                        checked={tag.checked}
                        onChange={(e) => handleChangeTags(e, data.id, tagIndex)}
                      />
                    </div>
                  ))}
              </div>
            </li>
          </ul>
        </div>
      );
    } else if (singleData && singleData.designType === "attachment") {
      return (
        <div className="attachment">
          {singleData.dropDownData && singleData.dropDownData.length > 0 && (
            <div
              onMouseEnter={() =>
                handleAttachmentMouseEnter(`${singleData.questionId}-${index}`)
              }
              onMouseLeave={handleAttachmentMouseLeave}
            >
              <OverlayTrigger
                placement="right"
                show={attachmentPopover === `${singleData.questionId}-${index}`}
                overlay={
                  <Popover id={`popover-${singleData.questionId}-${index}`}>
                    <div className="attachment-info-box rounded-3 bg-white">
                      <ul className="attachment-list">
                        {singleData.dropDownData &&
                          singleData.dropDownData.length > 0 &&
                          singleData.dropDownData.map((file, fileIndex) => {
                            // const fileName =
                            //    file.value && getFileNameFromUrl(file.value);
                            return (
                              <li
                                key={`${file.value}${fileIndex}`}
                                className="text-xs font-semibold text-slate-500"
                              >
                                <a
                                  href={file.value}
                                  target="_blank"
                                  rel="noopener noreferrer"
                                  className="d-flex align-items-center column-gap-2"
                                >
                                  {file.name}{" "}
                                  <i className="bx bx-down-arrow-circle text-lg"></i>
                                </a>
                              </li>
                            );
                          })}
                      </ul>
                    </div>
                  </Popover>
                }
              >
                <div className="attachment-box">
                  <i className="bx bx-link-alt"></i>{" "}
                  {singleData.dropDownData && singleData.dropDownData.length}{" "}
                  File{" "}
                </div>
              </OverlayTrigger>
            </div>
          )}
        </div>
      );
    } else {
      return (
        <div
          className="tableFeildEdit"
          onDoubleClick={
            singleData && singleData.editable
              ? () => handleTableEditFeild(key, index)
              : null
          }
          onMouseEnter={() => {
            if (
              singleData?.value &&
              !isNaN(singleData?.value) &&
              Number(singleData?.value > 0) &&
              singleData?.mouseHoverType === "averagescore"
            ) {
              getAvarageScoreUsersByTask(data.id);
            } else if (singleData?.mouseHoverType === "unversityranking") {
              getUniversityRankingByTask(data.id, singleData.questionId);
            }
          }}
          onMouseLeave={() => {
            setAvarageScoreUserList([]);
            setUniversityRankingList([]);
          }}
        >
          <div className="applicant-dropdown hover-effect position-relative">
            <CustomTooltip text={singleData && singleData.value}>
              <label
                className="oneline-ellipsis"
                htmlFor="JU12565829"
                // onDoubleClick={
                //   singleData && singleData.editable
                //     ? () => handleTableEditFeild(key, index)
                //     : null
                // }
              >
                {data[key] && data[key].value}
              </label>
            </CustomTooltip>
            {singleData?.mouseHoverType === "averagescore" &&
              avarageScoreUserList &&
              avarageScoreUserList.length > 0 &&
              singleData?.value !== undefined &&
              singleData?.value !== null &&
              Number(singleData.value) !== NaN &&
              Number(singleData.value) !== 0 && (
                <div className="review-info-box card-shadow">
                  {avarageScoreUserList.map((user) => (
                    <div className="d-flex align-items-center column-gap-1 mb-2 progress-green-900">
                      <div className="img-box rounded-circle overflow-hidden">
                        {user.photoURL ? (
                          <img
                            src={user.photoURL}
                            alt={`${user.firstName}-${user.lastName}`}
                            className="w-100 h-100 object-fit-cover"
                          />
                        ) : (
                          getFirstLetterOfName(user)
                        )}
                      </div>
                      <div className="w-100">
                        <h6 className="size-xs">
                          {user.firstName} {user.lastName}
                        </h6>
                      </div>
                      <div className="py-2 px-3 bg-grey-50 rounded-1">
                        {user.score}
                      </div>
                    </div>
                  ))}
                </div>
              )}

            {singleData?.mouseHoverType === "unversityranking" &&
              universityRankingList?.length > 0 && (
                <div className="hover-box rounded-2 position-absolute top-100 start-0 shadow z-3">
                  <div className="univercity-ranking max-w-400">
                    <div className="rounded-3 shadow bg-white">
                      <div className="p-3 border-bottom">
                        <h4 className="mb-0 text-sm font-semibold text-slate-600 text-wrap">
                          {singleData?.value}
                        </h4>
                      </div>
                      <div className="p-3">
                        <ul className="list-unstyled d-flex flex-column row-gap-3">
                          {universityRankingList.map(
                            (ranking, rankingIndex) => (
                              <li
                                className="d-flex align-items-center"
                                key={rankingIndex.toString()}
                              >
                                <div className="flex-none w-8 h-8 rounded-circle overflow-hidden me-2 bg-black-100">
                                  <img
                                    src={ranking.image}
                                    alt={ranking.type}
                                    className="w-100 h-100 object-fit-contain"
                                  />
                                </div>
                                <span className="me-2 font-medium">
                                  {ranking.type}
                                </span>{" "}
                                <span className="ms-auto px-2 py-1 rounded-1 text-xs font-semibold text-red-600 bg-red-100">
                                  {ranking.ranking}
                                </span>
                              </li>
                            )
                          )}
                        </ul>
                      </div>
                    </div>
                  </div>
                </div>
              )}
          </div>
        </div>
      );
    }
  };

  const tableFormRender = (data, singleData, key, index) => {
    if (singleData.fieldType === "select") {
      const dataList =
        (singleData &&
          singleData.dropDownData &&
          singleData.dropDownData.length > 0 &&
          singleData.dropDownData.map((option) => ({
            value: option.value,
            label: option.name,
          }))) ||
        [];
      const selectedValue =
        dataList && dataList.find((obj) => obj.value === singleData.value);
      return (
        // <ReactSelect
        //   className="basic-single"
        //   classNamePrefix="select"
        //   isClearableX
        //   isSearchable
        //   name="color"
        //   options={dataList}
        //   value={selectedValue}
        //   onChange={(value) => handleTableSelectChange(value, key, index)}
        //   onKeyDown={(e) => handleTableSelectPress(e, selectedValue, data, key)}
        // />
        <select
          className="form-control"
          value={selectedValue?.value || ""}
          onChange={(e) => handleTableSelectChange(e.target.value, key, index)}
        >
          <option value="">Select</option>
          {dataList.map((opt, optIndex) => (
            <option value={opt.value} key={`${opt.value}-${optIndex}`}>
              {opt.label}
            </option>
          ))}
        </select>
      );
    }
    return (
      <input
        type={singleData.fieldType}
        value={singleData.value}
        onChange={(e) => handleTableInputChange(e, key, index)}
        onKeyDown={(e) =>
          handleTableKeyPress(e, data, key, singleData.fieldType)
        }
        className="form-control form-control-sm from-control-date"
      />
    );
  };

  const CustomOption = (props) => {
    const { data, innerRef, innerProps } = props;
    return (
      <div
        ref={innerRef}
        {...innerProps}
        className="d-flex justify-center align-items-center gap-1 px-2 py-1 text-sm font-normal text-slate-600"
      >
        <span className="text-nowrap">{data.label}</span>
        <span className="badge bg-blue-100 text-blue-800 d-flex justify-center align-items-center leading-3 ms-auto">
          {data.count}
        </span>
      </div>
    );
  };

  const CustomSingleValue = (props) => {
    const { data } = props;

    return (
      <div className="d-flex justify-center align-items-center gap-1 py-1 text-sm font-normal text-slate-600 add-multiple-tab">
        <span className="text-nowrap">{data.label}</span>
        <span className="badge bg-blue-100 text-blue-800 d-flex justify-center align-items-center leading-3 ms-auto">
          {data.count}
        </span>
      </div>
    );
  };

  // Redirect
  const {
    admin: {
      applicationStatus: { root: applicationStatus, overview },
    },
  } = paths;

  const redirectTo = (data) => {
    navigate(
      `${applicationStatus}/${data.id}${overview}?projectId=${projectid}&stageId=${globalStage.current}`
    );
  };

  return (
    <>
      <main className="main">
        <div className="page-title-box d-md-flex justify-content-between align-items-center">
          <h4 className="page-title">{projectName}</h4>
          <div
            className="align-items-center"
            role="alert"
            aria-live="assertive"
            aria-atomic="true"
          ></div>
          <button
            type="button"
            className="btn btn-secondary btn-sm"
            onClick={onResetFilterAndSearch}
          >
            {t("common.button.clearAll")}
          </button>
        </div>

        <div className="d-flex flex-column gap-3">
          <div className="data-search position-relative border-bottom z-15">
            <div className="d-flex flex-wrap align-items-center">
              <div className="">
                <div className="slide-status-nav dashboard-slidenav d-flex align-items-center gap-2">
                  <div
                    className="d-flex flex-wrap align-items-center column-gap-2 row-gap-1"
                    // {...settings} ref={sliderRef}
                  >
                    {applicationStageSlider &&
                      applicationStageSlider.length > 0 &&
                      applicationStageSlider.map((stage, index) => (
                        <div
                          className={
                            stage.stageId === globalStage.current
                              ? "active nav-status-item"
                              : "nav-status-item"
                          }
                          key={index.toString()}
                        >
                          <button
                            className="text-sm font-medium text-slate-500 border-0 bg-transparent d-flex align-items-center gap-1 text-nowrap"
                            onClick={() =>
                              updateApplicationStage(stage.stageId)
                            }
                          >
                            {stage.name}{" "}
                            <span className="badge bg-blue-100 text-blue-800 d-flex justify-center align-items-center leading-3">
                              {stage.number}
                            </span>
                          </button>
                        </div>
                      ))}
                  </div>
                  {applicationStageDropdown.length > 0 && (
                    <div
                      className={`application-dropdown d-flex align-items-center position-relative ${
                        applicationStageDropdown?.find(
                          (stage) => stage.value === globalStage.current
                        )
                          ? "active"
                          : ""
                      }`}
                    >
                      <ReactSelect
                        className="application-stage-select"
                        // classNamePrefix="select"
                        isClearableX
                        isSearchable
                        // menuIsOpen
                        name="applicationStageDropdown"
                        options={applicationStageDropdown}
                        value={
                          applicationStageDropdown?.find(
                            (stage) => stage.value === globalStage.current
                          ) || null
                        }
                        onChange={(stage) =>
                          updateApplicationStage(stage.value)
                        }
                        components={{
                          Option: CustomOption,
                          SingleValue: CustomSingleValue,
                        }}
                      />
                    </div>
                  )}
                </div>
              </div>
              <div className="ms-auto">
                <ul className="filter-list d-flex gap-1">
                  <li>
                    <Button
                      variant="bg-light"
                      className="px-1 py-1 text-sm text-slate-700 bg-transparent text-nowrap d-flex align-items-center gap-1"
                      onClick={toggleFiltersModal}
                    >
                      <i className="pluto-filter"></i>{" "}
                      {t("common.button.filters")}
                      {filterCount > 0 && (
                        <span className="badge bg-blue-100 text-blue-800 d-flex justify-center align-items-center leading-3 badge-bg-dynamic">
                          {filterCount}
                        </span>
                      )}
                    </Button>
                  </li>
                  <li>
                    <Button
                      variant="bg-light"
                      className="px-1 py-1 text-sm text-slate-700 bg-transparent text-nowrap"
                      onClick={toggleColumsModal}
                    >
                      <i className="bx bx-menu"></i>{" "}
                      {t("common.button.editColumn")}
                    </Button>
                  </li>
                </ul>
              </div>
            </div>
          </div>

          <div className="search-div search-list-tag border border-slate-200 rounded bg-slate-50">
            <span className="search-ico">
              <i className="pluto-search"></i>
            </span>
            <TagsInput
              addKeys={[9, 13, 32]}
              inputProps={{
                placeholder: t("common.placeHolder.searchApplicant"),
              }}
              value={searchArr}
              onChange={handleSearch}
            />
          </div>

          <ul className="search-group">
            {actionList &&
              actionList.length > 0 &&
              actionList.map((action, actionIndex) => (
                <li key={actionIndex.toString()}>
                  {(action.type === "Button" ||
                    action.type === "Export" ||
                    action.type === "OfferLetter" ||
                    action.type === "SendEmail") && (
                    <button
                      style={{
                        backgroundColor: action.backgroundColor
                          ? action.backgroundColor
                          : "#64D06F",
                        color: action.fontColor ? action.fontColor : "#FFFFFF",
                      }}
                      className="button"
                      type="button"
                      onClick={() => {
                        if (action.type === "Export") {
                          onExportAction();
                        } else if (action.type === "OfferLetter") {
                          toggleOfferLetterModal();
                        } else if (action.type === "SendEmail") {
                          toggleEmailTemplateModal();
                        } else {
                          onSubmitAction(action.name);
                        }
                      }}
                      disabled={
                        selectedIds.length > 0 && !actionLoading ? false : true
                      }
                    >
                      {action.name}
                    </button>
                  )}
                  {action.type === "Upload" && (
                    <div
                      style={{
                        backgroundColor: action.backgroundColor
                          ? action.backgroundColor
                          : "#64D06F",
                        fontColor: action.fontColor
                          ? action.fontColor
                          : "#FFFFFF",
                      }}
                      className={`upload-btn-wrapper rounded-2 cursor-pointer ${
                        selectedIds.length > 0 ? "" : "disabled-btn"
                      }`}
                      // type="button"
                    >
                      <button className="button text-white">
                        {/* <i className="bx bx-cloud-upload me-1"></i> */}
                        {action.name}
                        <input
                          type="file"
                          onChange={(e) => onUploadDocument(e, action.name)}
                          accept={DEFAULT_DOCUMENT_TYPE.toString()}
                          className="ms-2"
                          disabled={selectedIds.length > 0 ? false : true}
                        />
                      </button>
                    </div>
                  )}
                </li>
              ))}
          </ul>

          <div className="table-container project-table-height" ref={tableRef}>
            {headerList && headerList.length > 0 && (
              <table className="table data-table border-start border-end border-slate-200">
                <thead className="table-light">
                  <tr>
                    {headerList.map((header, headerIndex) => (
                      <th key={headerIndex.toString()}>
                        {tableHeaderRender(
                          header,
                          headerIndex === 0 ? "firstChild" : ""
                        )}
                      </th>
                    ))}
                  </tr>
                </thead>
                <tbody>
                  {tableLoading ? (
                    <tr className="loading-screen">
                      <td colSpan={12}>
                        <LoadingScreen />
                      </td>
                    </tr>
                  ) : (
                    <>
                      {totalApplicants.current >= 1 &&
                      applicantList &&
                      applicantList.length > 0 ? (
                        applicantList.map((data, index) => (
                          <tr key={index.toString()}>
                            {headerList.map((key, keyIndex) => (
                              <td key={keyIndex.toString()}>
                                <div className="form-check">
                                  {keyIndex === 0 && (
                                    <input
                                      className="form-check-input"
                                      type="checkbox"
                                      checked={data.isChecked ?? false}
                                      id={data.id}
                                      name={data.id}
                                      onChange={handleSelectRow}
                                    />
                                  )}
                                  {data[key] && data[key].makeEditable
                                    ? tableFormRender(
                                        data,
                                        data[key],
                                        key,
                                        index
                                      )
                                    : tableBodyRender(
                                        data,
                                        data[key],
                                        key,
                                        index
                                      )}
                                </div>
                              </td>
                            ))}
                          </tr>
                        ))
                      ) : (
                        <tr>
                          <td colSpan={headerList.length}>
                            <h4 className="text-md">No Data Found</h4>
                          </td>
                        </tr>
                      )}
                    </>
                  )}
                </tbody>
              </table>
            )}
            {applicantList.length < totalApplicants.current && (
              <div className="px-3 py-2 d-flex flex-column juatify-content-center row-gap-2 rounded-sm bg-white shadow position-absolute table-progressbar">
                <div className="d-flex align-items-center gap-4">
                  <span className="text-xs font-semibold text-slate-500">
                    Table Data Loading
                  </span>
                  <span className="text-xxs text-slate-600">
                    {applicantList.length}/{totalApplicants.current}
                  </span>
                </div>
                <div>
                  <div className="progressbar-sm">
                    <ProgressBar
                      now={applicantList.length}
                      max={totalApplicants.current}
                    />
                  </div>
                </div>
              </div>
            )}
          </div>
        </div>
      </main>

      {filtersModal && (
        <Filters
          show={filtersModal}
          filterList={filterList}
          duplicateFilterList={duplicateFilterList}
          setFilterList={setFilterList}
          toggle={toggleFiltersModal}
          onApplyFilter={onApplyFilter}
          onResetFilter={onResetFilter}
        />
      )}

      {columnsModal && (
        <Columns
          show={columnsModal}
          projectid={projectid}
          toggle={toggleColumsModal}
          onApplyColumnChanges={onApplyColumnChanges}
          fetchApplicantHeaderList={fetchApplicantHeaderList}
        />
      )}

      {isCommentShow.isOpen && (
        <GlobalChat
          show={isCommentShow.isOpen}
          toggle={toggleCommentModal}
          taskId={isCommentShow.taskId}
        />
      )}

      {offerLetterModal && (
        <OfferLetter
          show={offerLetterModal}
          toggle={toggleOfferLetterModal}
          taskIds={selectedIds}
        />
      )}

      {emailTemplateModal && (
        <OfferLetter
          isEmailTemplate
          show={emailTemplateModal}
          taskIds={selectedIds}
          toggle={toggleEmailTemplateModal}
        />
      )}

      {applicantDetailsModal && (
        <ApplicantDetails
          show={applicantDetailsModal}
          gid={selectedApplicantId}
          projectId={projectid}
          toggle={toggleApplicantDetailsModal}
        />
      )}
    </>
  );
}
